<template>
  <div class="app-container">
    <el-container>
      <el-aside width="400px" class="cbox-p14">
        <div class="section-header">功能菜单</div>
        <div class="search-box">
          <el-input v-model.trim="filterText" placeholder="输入关键词进行筛选" prefix-icon="el-icon-search" clearable></el-input>
        </div>
        <div class="button-box">
          <el-button type="primary" @click="handleAddOrigin">新增根菜单</el-button>
          <el-button type="primary" @click="handleAddChildren" plain>新增下级菜单</el-button>
          <el-button type="danger" @click="handleDelete">删除</el-button>
        </div>
        <div class="tree-box">
          <el-tree
            ref="tree"
            :data="treeData"
            :current-node-key="currentNodeId"
            node-key="id"
            highlight-current
            :props="defaultProps"
            :expand-on-click-node="false"
            :filter-node-method="filterNode"
            @node-click="handleTreeNode"
          >
            <span class="custom-tree-node" slot-scope="{ node }">
              <span>{{ node.label }}</span>
            </span>
          </el-tree>
        </div>
      </el-aside>

      <el-main class="cbox-p14">
        <div class="section-header">菜单信息</div>

        <el-form
          v-show="this.editForm.levelCode"
          ref="editForm"
          class="dashed-border"
          v-loading="infoLoading"
          :model="editForm"
          :rules="rules"
          label-width="120px"
        >
          <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
            <el-col :span="24">
              <el-form-item label="上级菜单" prop="parentName">
                <el-input v-model.trim="editForm.parentName" placeholder="" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="菜单名称" prop="name">
                <el-input v-model.trim="editForm.name" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="菜单编码" prop="code">
                <el-input v-model.trim="editForm.code" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="层级编码" prop="levelCode">
                <el-input v-model.trim="editForm.levelCode" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="基础路径" prop="base">
                <el-input v-model.trim="editForm.base" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="菜单页面" prop="url">
                <el-input v-model.trim="editForm.url" placeholder="请输入" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="菜单类型" prop="functype">
                <el-radio-group v-model="editForm.functype">
                  <el-radio label="1">目录</el-radio>
                  <el-radio label="2">操作</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否可用" prop="deleted">
                <el-switch
                  v-model="editForm.deleted"
                  :active-value="0"
                  :inactive-value="1"
                  active-text="启用"
                  inactive-text="禁用"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="图标" prop="icon">
                <el-input v-model.trim="editForm.icon" style="width: 60%" clearable></el-input>
                <el-button type="primary" @click="chooseIcon">选择图标</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="说明" prop="remark">
                <el-input type="textarea" v-model="editForm.remark" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div v-if="this.editForm.levelCode" class="form-buttons">
          <el-button :loading="saveLoading" type="primary" @click="handleSave">保存</el-button>
        </div>

        <el-empty v-if="!this.editForm.levelCode" description="请选择菜单信息"></el-empty>
      </el-main>
    </el-container>

    <!--图标弹窗 开始-->
    <drag-dialog title="图标选择" :visible.sync="iconVisiable" width="600px" height="400px" :close-on-click-modal="false">
      <div class="am-attend">
        <icon-fonts @chooseIcon="choose" />
      </div>

      <template slot="footer">
        <el-button @click="closeIcon">关 闭</el-button>
      </template>
    </drag-dialog>
    <!--图标弹窗 结束-->
  </div>
</template>

<script>
import iconFonts from '@/components/IconFonts';

import { getFunctionData, getFunction, saveFunction, deleteFunction } from '@/api/system';

import { getNextCode } from '@/utils/index';

export default {
  components: { iconFonts },
  data() {
    return {
      filterText: '',
      defaultProps: {
        children: 'nodes',
        label: 'text'
      },
      treeData: [],
      infoLoading: false,
      currentTreeNode: null,
      currentNodeId: null,
      editForm: {
        parentId: null,
        parentName: '',
        functype: '1',
        deleted: 0
      },
      rules: {
        name: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入菜单编码', trigger: 'blur' }]
      },
      iconVisiable: false,
      saveLoading: false
    };
  },
  computed: {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.text.indexOf(value) !== -1;
    },
    async getFunctionData() {
      const data = await getFunctionData();
      this.treeData = data || [];
    },
    async getFunction(id) {
      this.infoLoading = true;
      try {
        const data = await getFunction(id);
        this.editForm = {
          id: data.id,
          version: data.version,
          parentId: data.parentId ?? '',
          parentName: data.parentName ?? '',
          name: data.name ?? '',
          code: data.code ?? '',
          levelCode: data.levelCode ?? '',
          base: data.base ?? '',
          url: data.url ?? '',
          functype: data.functype ?? null,
          remark: data.remark || '',
          icon: data.icon || '',
          deleted: data.deleted
        };
      } finally {
        this.infoLoading = false;
      }
    },
    handleTreeNode(nodeData) {
      this.currentTreeNode = nodeData;
      const id = nodeData.id;
      this.currentNodeId = id;
      this.getFunction(id);
    },
    resetTreeNode() {
      this.currentTreeNode = null;
      this.currentNodeId = null;
      this.handleReset();
      this.getFunctionData();
    },
    handleAddOrigin() {
      this.infoLoading = true;
      this.handleReset();

      this.$nextTick(() => {
        const lastCode = this.treeData?.[this.treeData.length - 1]?.levelCode ?? null;
        let levelCode = getNextCode('', lastCode, 6);
        this.editForm = { ...this.editForm, levelCode };
        this.infoLoading = false;
      });
    },
    handleAddChildren() {
      const currentNode = this.currentTreeNode;
      if (!currentNode?.id) return this.$message.warning('请先选择要操作的上级菜单！');
      this.infoLoading = true;
      this.handleReset();

      this.$nextTick(() => {
        let lastCode = currentNode.nodes ? currentNode.nodes[currentNode.nodes.length - 1].levelCode : null;
        let levelCode = getNextCode(this.currentTreeNode.levelCode, lastCode, 6);
        this.editForm = { ...this.editForm, parentId: this.currentTreeNode.id, parentName: this.currentTreeNode.text, levelCode };
        this.infoLoading = false;
      });
    },
    handleReset() {
      this.$refs.editForm.resetFields();
      this.editForm = {
        parentId: null,
        parentName: '',
        functype: '1',
        deleted: 0
      };
    },
    handleSave() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.saveLoading = true;
          try {
            await saveFunction(this.editForm);
            this.$message.success('保存成功!');
            this.resetTreeNode();
          } finally {
            this.saveLoading = false;
          }
        }
      });
    },
    handleDelete() {
      const id = this.currentTreeNode?.id ?? null;
      if (!id) return this.$message.warning('请先选择要操作的菜单！');
      if (this.currentTreeNode?.nodes?.length > 0) return this.$message.warning('该节点含有子菜单，请先删除子菜单！');

      this.$confirm('确定删除所选信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await deleteFunction(id);
          this.resetTreeNode();
          this.$message.success('删除成功');
        })
        .catch(() => {});
    },
    //选择图标
    choose(icon) {
      this.editForm.icon = icon;
      this.iconVisiable = false;
    },
    //图标选择
    chooseIcon() {
      this.iconVisiable = true;
    },

    //关闭图标选择器
    closeIcon() {
      this.iconVisiable = false;
    }
  },
  created() {},
  mounted() {},
  activated() {
    this.getFunctionData();
  }
};
</script>

<style lang="scss" scoped>
.el-container {
  height: 100%;
  overflow: visible;
}
.el-aside {
  display: flex;
  flex-direction: column;
  height: 100%;
  &.cbox-p14 {
    padding-top: 0;
  }

  .search-box {
    display: flex;
    align-items: center;

    .el-button {
      margin-left: 14px;
    }
  }
  .button-box {
    margin: 10px 0;
  }
  .tree-box {
    flex: 1 1 auto;
    min-height: 0;
  }
}
.el-main {
  margin-left: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .dashed-border {
    flex: 1 1 auto;
    min-height: 0;
    padding: 14px 14px 0 0;
    margin-bottom: 10px;
    overflow: hidden;
    overflow-y: auto;
  }
  .form-buttons {
    text-align: right;
  }
  .el-empty {
    height: 100%;
  }
  &.cbox-p14 {
    padding-top: 0;
  }
}

.section-header {
  line-height: 40px;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}
</style>
